import React from 'react';
import {Nav} from 'reactstrap';
import ProfileDropdown from './ProfileDropdown';
import ThemeToggle from './ThemeToggle';

const TopNavRightSideNavItem = () => {
  return (
    <Nav navbar className="navbar-nav-icons ml-auto flex-row align-items-center">
      <ThemeToggle />
      <ProfileDropdown />
    </Nav>
  );
};

export default TopNavRightSideNavItem;
